import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null,
        title: '',
    },
    mutations: {
        SET_USER_DATA(state, userData) {
            localStorage.setItem('user', JSON.stringify(userData))
            axios.defaults.headers.common['Authorization'] = `Bearer ${
                userData.token
            }`
            state.user = userData
        },
        LOGOUT() {
            localStorage.removeItem('user')
            location.reload()
        },
        SET_TITLE(state, title) {
            state.title = title
            document.title = title + ' - Digitalks'
        },
    },
    actions: {
        login({commit}, credentials) {
            return axios
                .post('/api/v1/login', credentials)
                .then(({data}) => {
                    commit('SET_USER_DATA', data)
                })
        },
        logout({commit}) {
            commit('LOGOUT')
        },
        set_title({commit}, title) {
            commit('SET_TITLE', title)
        },
    },
    modules: {},
    getters: {
        title: state => state.title
    }
})
